import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store.js'

//IMPORT ROUTES
import auth from './routes/auth'
import miscellanies from './routes/miscellanies'
import home from './routes/home'
import notifications from './routes/notifications'
import profile from './routes/profile'
import activityCenter from './routes/activityCenter'
import messageCenter from './routes/messageCenter'
import users from './routes/users';
import user from './routes/user';
import projects from './routes/projects';
import partners from './routes/partners';
import posts from './routes/posts';
import tags from './routes/tags';
import categories from './routes/categories';
import testimonials from './routes/testimonials';
import solutions from './routes/solutions';
import services from './routes/services';
import emails from './routes/emails';
import applications from './routes/applications';

Vue.use(VueRouter);

var allRoutes = [];
allRoutes = allRoutes.concat(auth, miscellanies, home, profile, activityCenter, messageCenter, users, user, posts, projects, partners, tags, categories, testimonials, solutions, services, notifications, emails, applications);

const routes = allRoutes;

const router = new VueRouter({
	mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {
	/*store.dispatch('chechAuth');*/
	
	let isLoggedIn = store.state.auth.isLoggedIn;
	let isAuthRequired = to.matched.some(record => record.meta.auth);
	let isAdmin = to.matched.some(record => record.meta.admin);
	
	if(isAuthRequired && !isLoggedIn) {
		next('/');
	}else if(!isAuthRequired && isLoggedIn) {
		next('/escritorio');
	}else {
		next();
	}

	window.scrollTo(0, 0);
});

export default router;